<ng-container *ngIf="option.linkRef; else noLink">
  <!--TODO: refactor to use link for the whole item instead only word!-->
  <a [customRouterLink]="option.linkRef" class="option {{ option.selected ? 'active' : '' }}">
    <span>{{ option.value }}</span>
  </a>
</ng-container>
<ng-template #noLink>
  <div class="option {{ option.selected ? 'active' : '' }}" (click)="optionSelected()">
    <img src="./assets/ui/shared/icons/checked_icon_red.svg">
    <span>{{ option.value }}</span>
  </div>
</ng-template>
